export const importedretailerserrors = [
    {
        'id': '1',
        'fileId': 31,
        'errorCode': '1002',
        'description': 'The headers are not correct',
        'lineFile': 1
    }
];